/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_RandomInputs */

const en_landing_studio_random = /** @type {(inputs: Landing_Studio_RandomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Random`)
};

const zh_landing_studio_random = /** @type {(inputs: Landing_Studio_RandomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随机`)
};

/**
* | output |
* | --- |
* | "Random" |
*
* @param {Landing_Studio_RandomInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_random = /** @type {((inputs?: Landing_Studio_RandomInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_RandomInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_random(inputs)
	return zh_landing_studio_random(inputs)
});
export { landing_studio_random as "landing.studio.random" }